module.exports = __webpack_public_path__ + "img/home-img.352952ca.png";